import { FootnotesDataJSON } from '@owc-types/BaseDataJSON';

/*
 * TODO: This util is a placeholder whilst the footnotes continue to be passed
 * as an empty array when not available from the BE to us. The ticket related
 * to the BE fixed is: https://jira.mercedes-benz.io/browse/CINOWF-28685.
 *
 */
export const getFootnotesIfAvailable = (footnotesData?: FootnotesDataJSON): FootnotesDataJSON | null => {
  if (footnotesData?.footnotes && footnotesData.footnotes.length > 0) {
    return {
      footnotes: footnotesData.footnotes,
      darkMode: footnotesData.darkMode,
    };
  }

  return null;
};
